"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStackOpcodeTemplates = getStackOpcodeTemplates;
function getStackOpcodeTemplates() {
    return `
                        // Stack Operations
                        case opMap[0]: { // PUSH_CONST
                            stack.push(constants[arg]);
                            pc++;
                            break;
                        }

                        case opMap[1]: { // PUSH_UNDEFINED
                            stack.push(undefined);
                            pc++;
                            break;
                        }

                        case opMap[2]: { // PUSH_NULL
                            stack.push(null);
                            pc++;
                            break;
                        }

                        case opMap[3]: { // POP
                            stack.pop();
                            pc++;
                            break;
                        }

                        case opMap[4]: { // DUP
                            // Pop (decodes if stack encoding enabled), then push twice (encodes each)
                            // This ensures proper encoding behavior when vmStackEncoding is active
                            let dupVal = stack.pop();
                            stack.push(dupVal);
                            stack.push(dupVal);
                            pc++;
                            break;
                        }

                        case opMap[5]: { // SWAP
                            let stackLen = stack.length;
                            let tmp = stack[stackLen - 1];
                            stack[stackLen - 1] = stack[stackLen - 2];
                            stack[stackLen - 2] = tmp;
                            pc++;
                            break;
                        }

                        case opMap[6]: { // LOAD_LOCAL
                            stack.push(locals[arg]);
                            pc++;
                            break;
                        }

                        case opMap[7]: { // STORE_LOCAL
                            locals[arg] = stack.pop();
                            pc++;
                            break;
                        }

                        case opMap[8]: { // LOAD_ARG
                            stack.push(args[arg]);
                            pc++;
                            break;
                        }

                        case opMap[9]: { // STORE_ARG
                            args[arg] = stack.pop();
                            pc++;
                            break;
                        }
    `;
}
